import { render, staticRenderFns } from "./BasicTextarea.vue?vue&type=template&id=77d45af5"
import script from "./BasicTextarea.vue?vue&type=script&lang=js"
export * from "./BasicTextarea.vue?vue&type=script&lang=js"
import style0 from "./BasicTextarea.vue?vue&type=style&index=0&id=77d45af5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports